import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../classes/user';

@Pipe({
  name: 'userFilter',
  pure: false
})
export class UserFilterPipe implements PipeTransform {

  transform(userList: Array<User>, filterValue: string): any {
    if (!userList || !filterValue) {
      return userList;
    }
    return userList.filter((user: User) => {
      return user.Username.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
    });
  }

}
